import { useMutation } from '@tanstack/react-query';
import { useApiClient } from './useApiClient.ts';

export interface DataLinkOnboardingRequest {
  email: string;
  customerId: number;
}

export interface DataLinkOnboardingResponse {
  username: string;
  temporaryPassword: string;
}

export function useDataLinkOnboarding() {
  const apiClient = useApiClient();

  // Onboard customer mutation
  const onboardCustomerMutation = useMutation({
    mutationFn: async (
      data: DataLinkOnboardingRequest,
    ): Promise<DataLinkOnboardingResponse> => {
      return await apiClient.post<DataLinkOnboardingResponse>(
        'datalink/onboard',
        data,
      );
    },
  });

  return {
    onboardCustomer: onboardCustomerMutation.mutateAsync,
    isSubmitting: onboardCustomerMutation.isPending,
  };
}
